/* @flow */

import Type from '../types/Type';

export default class Declaration extends Type {
  name: string;
}